import React from "react";
import { Table } from "antd";
import { Step2VM, TestStepDto } from "../../autogenerated/models";

interface SelectedTestCasesTableProps {
  choices: Step2VM;
}

const SelectedTestCasesTable: React.FC<SelectedTestCasesTableProps> = ({
  choices = {},
}) => {
  const testCaseColumns = [
    { title: "Identifier", dataIndex: "identifier", key: "identifier" },
    { title: "Test case name", dataIndex: "name", key: "name" },
    {
      title: "Requires inspection?",
      dataIndex: "testSteps",
      key: "testSteps",
      render: (steps: TestStepDto[]) => (
        <>{steps.some((step) => !step.requiresValidation) ? "Yes" : "No"}</>
      ),
    },
  ];

  return (
    <Table
      columns={testCaseColumns}
      dataSource={choices.selectedTestCases}
      pagination={false}
      size="small"
    />
  );
};

export default SelectedTestCasesTable;
